import React from "react";
import RegistrationForm from "../../Components/RegistrationForm/RegistrationForm";
import GooLoader from "../../Components/GooLoader/GooLoader";
import SuccessBox from "../../Components/SuccessBox/SuccessBox";
import ErrorBox from "../../Components/ErrorBox/ErrorBox";
import { Helmet } from "react-helmet-async";
import jwt_decode from "jwt-decode";
import call from "../../API/API";
import "./VerifyEmailCode.css";

class VerifyEmailCode extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: true,
      successBoxTitle: "",
      successBoxBody: "",
      errorBoxTitle: "",
      errorBoxBody: "",
      verification_success: false,
    };

    this.showErrorBox = this.showErrorBox.bind(this);
    this.showSuccessBox = this.showSuccessBox.bind(this);
    this.handleResendEmail = this.handleResendEmail.bind(this);
    this.handleBackButton = this.handleBackButton.bind(this);
    this.handleNext = this.handleNext.bind(this);
  }

  componentDidMount() {
    const token = localStorage.getItem("token");
    if (!token) {
      this.props.history.push("/create-account");
    } else {
      const decoded = jwt_decode(token);
      if (decoded.email_verified === "active") {
        if (this.props.location.state && this.props.location.state.userData) {
          const userData = this.props.location.state.userData;
          const { name, lastname, email } = userData;
          if (name && lastname && email) {
            this.props.history.push("/for-founders-by-founders", {
              ...userData,
            });
          } else {
            call.users_API
              .getPersonalUserMatchingCriteria()
              .then((res) => {
                if (res.success) {
                  console.log(res.results);
                  const data = res.results;
                  const { name, lastname, email } = data;
                  if (name && lastname && email) {
                    this.props.history.push("/for-founders-by-founders", {
                      userData: {
                        name,
                        lastname,
                        email,
                      },
                    });
                  } else {
                    this.props.history.push("/error", {
                      error: "Something wrong happened!",
                    });
                  }
                } else {
                  this.props.history.push("/error", { error: res.results });
                }
              })
              .catch((err) => {
                this.props.history.push("/error", { error: err.message });
              });
          }
        } else {
          call.users_API
            .getPersonalUserMatchingCriteria()
            .then((res) => {
              if (res.success) {
                console.log(res.results);
                const data = res.results;
                const { name, lastname, email } = data;
                if (name && lastname && email) {
                  this.props.history.push("/for-founders-by-founders", {
                    userData: {
                      name,
                      lastname,
                      email,
                    },
                  });
                } else {
                  this.props.history.push("/error", {
                    error: "Something wrong happened!",
                  });
                }
              } else {
                this.props.history.push("/error", { error: res.results });
              }
            })
            .catch((err) => {
              this.props.history.push("/error", { error: err.message });
            });
        }
      } else if (decoded.email_verified === "pending") {
        const verification_code = this.props.match.params["id"];
        const id = decoded.id;
        call.mail
          .verifyEmail(id, verification_code)
          .then((res) => {
            console.log(res);
            if (res.success) {
              const { token } = res;
              localStorage.setItem("token", token);
              this.setState(
                {
                  verification_success: true,
                },
                () => {
                  this.setState({
                    isLoading: false,
                  });
                }
              );
            } else if (res.results === "You already have verified the email.") {
              call.users_API
                .getPersonalUserMatchingCriteria()
                .then((res) => {
                  if (res.success) {
                    console.log(res.results);
                    const { name, lastname, email } = res.results;
                    this.props.history.push("/for-founders-by-founders", {
                      userData: {
                        name,
                        lastname,
                        email,
                      },
                    });
                  } else {
                    this.props.history.push("/error", { error: res.results });
                  }
                })
                .catch((err) => {
                  this.props.history.push("/error", { error: err.message });
                });
            } else {
              this.setState(
                {
                  verification_success: false,
                },
                () => {
                  this.setState({
                    isLoading: false,
                  });
                }
              );
            }
          })
          .catch((err) => {
            this.props.history.push("/error", { error: err.message });
          });
      } else {
        this.props.history.push("/error", {
          error: "Cannot identify your email, please login again.",
        });
      }
    }
  }

  showErrorBox(title, message) {
    this.setState(
      {
        errorBoxTitle: title,
        errorBoxBody: message,
      },
      () => {
        setTimeout(() => {
          this.setState({
            errorBoxTitle: "",
            errorBoxBody: "",
          });
        }, 3000);
      }
    );
  }

  showSuccessBox(title, message) {
    this.setState(
      {
        successBoxTitle: title,
        successBoxBody: message,
      },
      () => {
        setTimeout(() => {
          this.setState({
            successBoxTitle: "",
            successBoxBody: "",
          });
        }, 3000);
      }
    );
  }

  handleNext() {
    call.users_API
      .getPersonalUserMatchingCriteria()
      .then((res) => {
        if (res.success) {
          const { name, lastname, email } = res.results;
          this.props.history.push("/for-founders-by-founders", {
            userData: {
              name,
              lastname,
              email,
            },
          });
        } else {
          this.props.history.push("/error", { error: res.results });
        }
      })
      .catch((err) => {
        this.props.history.push("/error", { error: err.message });
      });
  }

  handleResendEmail() {
    const token = localStorage.getItem("token");
    const id = jwt_decode(token).id;
    if (!id) {
      this.showErrorBox(
        "Error sending verification email",
        "Could not verify the user"
      );
    } else {
      call.mail
        .resendEmail(id)
        .then((res) => {
          if (res.success) {
            this.showSuccessBox("Success", res.results);
          } else {
            this.showErrorBox("Error", res.results);
          }
        })
        .catch((err) => {
          this.props.history.push("/error", { error: err.message });
        });
    }
  }

  handleBackButton() {
    localStorage.clear();
    this.props.history.push("/");
  }

  render() {
    if (this.state.verification_success) {
      return (
        <>
          {this.state.isLoading ? <GooLoader title="Verifying" /> : null}
          <RegistrationForm
            containerClassName="container-verify-email-code"
            hasCounter={false}
            hasQuote={true}
            quote="Please continue by clicking next."
            headerText="Email is verified successfully!"
            primaryButtonText="Next"
            hasSkip={false}
            handlePrimaryBtnOnClick={this.handleNext}
            activatePrimaryWithEnter={true}
            showButton={true}
            showRegisterLink={false}
            showBackButton={true}
            backButtonText="Back"
            handleBackButtonClick={this.handleBackButton}
          >
            <Helmet>
              <title>Astronomic Network</title>
              <meta
                name="description"
                content="Austin entrepreneurs helping each other win"
              />
            </Helmet>
          </RegistrationForm>
        </>
      );
    } else {
      return (
        <>
          {this.state.isLoading ? <GooLoader title="Verifying" /> : null}
          <RegistrationForm
            containerClassName="container-verify-email-code"
            hasCounter={false}
            hasQuote={true}
            quote="Click the resend button to resend verification email."
            headerText="Your email failed to verify"
            primaryButtonText="Resend"
            hasSkip={false}
            handlePrimaryBtnOnClick={this.handleResendEmail}
            activatePrimaryWithEnter={true}
            showButton={true}
            showRegisterLink={false}
            showBackButton={true}
            backButtonText="Back"
            handleBackButtonClick={this.handleBackButton}
          >
            <Helmet>
              <title>Astronomic Network</title>
              <meta
                name="description"
                content="Austin entrepreneurs helping each other win"
              />
            </Helmet>
          </RegistrationForm>
          <SuccessBox
            title={this.state.successBoxTitle}
            body={this.state.successBoxBody}
          />
          <ErrorBox
            title={this.state.errorBoxTitle}
            body={this.state.errorBoxBody}
          />
        </>
      );
    }
  }
}

export default VerifyEmailCode;
